import {
  actionCreator,
  checkHttpStatus,
  InsuranceActionTypes,
  jsonApiHeader,
  showSuccessMessage,
  showWarningMessage,
  showErrorMessage,
  GET_INSURANCE_TYPES_LIST_API,
  DELETE_INSURANCE_TYPE_API,
  POST_INSURANCE_TYPE_API,
  GET_INSURANCE_TYPE_DETAILS_API,
} from '../constants/ApiConstants';
import { checkHttpStatusAuthCheck, createSearchUrlForCustomAPI } from '../../../../../actions/utilAction';

export const getInsuranceTypeList = (searchObj) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(InsuranceActionTypes.get_insuranceTypesList.REQUEST));
    let query_params = createSearchUrlForCustomAPI(searchObj);
    fetch(`${GET_INSURANCE_TYPES_LIST_API}${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(InsuranceActionTypes.get_insuranceTypesList.SUCCESS, response));
        } else {
          dispatch(actionCreator(InsuranceActionTypes.get_insuranceTypesList.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error get_insuranceTypesList', error);
      });
  };
};

export const saveInsuranceTypes = (formData) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(InsuranceActionTypes.post_insuranceType.REQUEST));
    fetch(POST_INSURANCE_TYPE_API, {
      method: 'POST',
      body: JSON.stringify(formData),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(InsuranceActionTypes.post_insuranceType.SUCCESS, response));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(InsuranceActionTypes.post_insuranceType.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error post_insuranceType', error);
      });
  };
};

export const getInsuranceTypeDetails = (insuranceTypeId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(InsuranceActionTypes.get_insuranceTypeDetails.REQUEST));
    fetch(`${GET_INSURANCE_TYPE_DETAILS_API}?id=${insuranceTypeId}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(InsuranceActionTypes.get_insuranceTypeDetails.SUCCESS, response));
        } else {
          dispatch(actionCreator(InsuranceActionTypes.get_insuranceTypeDetails.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error get_insuranceTypeDetails', error);
      });
  };
};

export const deleteInsuranceType = (Id) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(InsuranceActionTypes.delete_insuranceType.REQUEST));
    fetch(`${DELETE_INSURANCE_TYPE_API}?id=${Id}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode === 200 || response.statusCode === 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(InsuranceActionTypes.delete_insuranceType.SUCCESS, response));
        } else if (response.statusCode === 401 || response.statusCode === 422) {
          showWarningMessage(response.message);
          dispatch(actionCreator(InsuranceActionTypes.delete_insuranceType.SUCCESS, null));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(InsuranceActionTypes.delete_insuranceType.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error delete_insuranceType', error);
      });
  };
};




// WEBPACK FOOTER //
// ./src/modules/Masters/components/insurance-master/actions/InsuranceActions.js